// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__lld6v","bigColWidth":"Table_bigColWidth__320qF","biggerColWidth":"Table_biggerColWidth__Em5r6","row":"Table_row__3HTjr","col":"Table_col__3fE7b"};